import styled from "styled-components";

export const AssetReportFooterStyle = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const AssetReportFooterLabelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
`;

export const AssetReportFooterTitle = styled.div`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #363c4b;
`;
export const AssetReportFooterEmail = styled.div`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 300;
  color: #747d93;
  display: flex;
  align-items: center;
`;

export const AssetReportFooterLogoDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
`;
